import React from "react";

import MySettingsForm from "./MySettingsForm";

const MySettings = () => <MySettingsForm />;

export default MySettings;
